import { Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'store/hooks';

type ProtectedLinkProps = {
  pathname: string;
  right?: boolean;
  children?: React.ReactNode;
};

const ProtectedLink: React.FC<ProtectedLinkProps> = ({ pathname, right = true, children }) => {
  // const location = useLocation(); // Move useLocation hook inside the component
  const { management } = useSelector((state) => state);
  const urlString = window.location.href;
  // 1. Create a URL object
  const url = new URL(urlString);
  // 2. Access the search property
  const queryString = url.search;

  return right ? (
    <Link
      component={RouterLink}
      to={{
        pathname,
        state: {
          searchParamsPage: management?.searchParams?.page,
          pathname: url?.pathname,
          searchParam: queryString,
        },
      }}
      underline="none"
      noWrap
    >
      {children}
    </Link>
  ) : (
    <div>{children}</div>
  );
};

export default ProtectedLink;
